import { useLeadershipWheelStore } from '../store/useLeadershipWheelStore';
import Button from '@/components/Button';
import { AnimatePresence, motion } from 'framer-motion';

export const ResetLeadershipWheelButton = ({ show }: { show: boolean }) => {
  const { leadershipWheelPage, onResetAllAnswers } = useLeadershipWheelStore();

  const buttonVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="col-span-5 mt-sh-30 flex w-full flex-col items-center justify-center gap-4 space-x-3 md:flex-row md:gap-0">
      <AnimatePresence>
        {show && (
          <motion.div
            key="reset-button"
            variants={buttonVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex">
            <Button size={'lg'} onClick={() => onResetAllAnswers()} theme="solid-white" className="!text-black">
              {leadershipWheelPage?.resetTheWheel || 'Reset the wheel'}
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
